import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { replaceWithData } from "../../../../util";
import { CustomColorPicker, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { ICardProps, ItemCard2 } from "./ItemCard";
import { ItemCardPropertyEditor } from "./ItemCardProperty";
import { DataSourcePropertyEditor } from "../../ui-props/DataSourceProperty";
import { Checkbox, Input } from "uxp/components";
import './ItemCardField.scss';
import { executeAndBind, IDataSource, IDataSourceBinding, useDataSourceContext } from "../../data-source-picker/datasource";
interface ICardFieldProperty extends IBaseInputFieldProperty, ICardProps {
    fieldLabel: IFieldTitleProps,
    binding: IDataSourceBinding,
    timeline: {
        enabled: boolean,
        dotColor: string,
        lineColor: string,
        dotSize: string,
        dotText: string,
        dotShape: string,
    },
}


export const Field: React.FunctionComponent<IUIFieldProps<ICardFieldProperty>> = (props) => {
    let { value, onChange } = props?.fieldProps || {};
    let datasources: IDataSource[] = props.uiProps?.datasources || [];
    let [dataList, setDataList] = React.useState<any[]>([]);

    let styles: React.CSSProperties = {}

    let { widgetData } = useDataSourceContext() || { widgetData: null };
    let isLiveMode = props.mode !== 'preview' && props.mode !== 'thumbnail';
    let binding = props?.fieldProps?.binding;
    React.useEffect(() => {
        if ((!props.mode || (props.mode != 'preview' && props.mode != 'thumbnail'))) {
            if (binding) {

                executeAndBind(props.fieldProps.uxpContext, binding, datasources, {})
                    .then((opts: any[]) => {
                        setDataList(opts);
                    })
                    .catch(console.error);
            }
            else {
                //TODO: setDataList to manually defined items
            }
        }
        else {
            setDataList([{ title: 'My title', subTitle: 'My Subtitle' }]);
        }
    }, [props.mode]);

    let replacer = isLiveMode ?
        (x: string) => replaceWithData(x || '', widgetData)
        : (x: string) => (x || '');


    return (
        <div className={`ui-field-card ui-field ${props.mode}`} >
            <FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
            {
                dataList.map((dl) => {
                    let rowReplacer = (x: string) => replaceWithData(x || '', { ...widgetData, row: dl });
                    return <ItemCard2 topBorder={false} bottomBorder={true} {...props?.fieldProps} replacer={rowReplacer} />
                })
            }
        </div>
    )
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ICardFieldProperty>> = (props) => {
    let datasources: IDataSource[] = props.parentUIProps?.datasources || [];
    let uiProps = props.uiProps;
    return <PropertyContainer>
        <PropertyGroup>
            <PropertyGroupTitle>Data Source</PropertyGroupTitle>
            <Property>
                <DataSourcePropertyEditor
                    binding={props.uiProps.binding}
                    context={props.uxpContext}
                    onChange={(binding) => props.onChange(Object.assign({}, props.uiProps, { binding }))}
                    onChangeAny={(p, v) => {
                        props.onChangeAny(p, v);
                    }}
                    sources={datasources}
                    target={'dictionary-array'}
                    title='Data Source'
                    contextData={props.contextData}
                    className='uxp-designer-data-source-selector'
                    designer={props.designer}
                />
            </Property>
        </PropertyGroup>
        <ItemCardPropertyEditor uxpContext={props.uxpContext} onChange={props.onChange} parentUIProps={props.parentUIProps} uiProps={props.uiProps} />
        <FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
        {uiProps.timeline && <PropertyGroup>
            <PropertyGroupTitle>Timeline</PropertyGroupTitle>
            <Property>
                <Checkbox checked={uiProps.timeline.enabled == true}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { timeline: Object.assign({}, uiProps.timeline, { enabled: s }) }))}
                    label={`Enable Timeline`}
                />
            </Property>
            <Property>
                <PropertyTitle>Line color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData} color={uiProps.timeline.lineColor}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { timeline: Object.assign({}, uiProps.timeline, { lineColor: s }) }))}

                />
            </Property>
            <Property>
                <PropertyTitle>Dot Color</PropertyTitle>
                <CustomColorPicker contextData={props.contextData} color={uiProps.timeline.dotColor}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { timeline: Object.assign({}, uiProps.timeline, { dotColor: s }) }))}

                />
            </Property>
            <Property>
                <PropertyTitle>Dot Size</PropertyTitle>
                <Input type='number' value={uiProps.timeline.dotSize}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { timeline: Object.assign({}, uiProps.timeline, { dotSize: s }) }))}

                />
            </Property>
            <Property>
                <PropertyTitle>Dot Text</PropertyTitle>
                <Input value={uiProps.timeline.dotText}
                    onChange={s => props.onChange(Object.assign({}, uiProps, { timeline: Object.assign({}, uiProps.timeline, { dotText: s }) }))}

                />
            </Property>

        </PropertyGroup>}
    </PropertyContainer>;
}

registerUIField({
    id: 'item-card-list',
    description: 'Item Card List',
    field: Field,
    propertyEditor: PropertyEditor,
    isInputField: true,
    defaultProps: {
        fieldLabel: {
            label: 'Text Label',
        },
        binding: null,
        imageField: '',
        imageSize: '30',
        imageType: '',
        imageBorderType: 'square',
        imageBackgroundColor: '',
        imageIcon: '',
        imageIconColor: '',
        titleField: '',
        titleColor: '',
        titleSize: '',
        subTitleField: '',
        subTitleColor: '',
        subTitleSize: '',
        borderColor: '',
        topLabels: [],
        bottomLabels: [],
        buttons: [],
        onClick: null,
        timeline: null,


    },
});


registerUIField({
    id: 'item-card-list',
    description: 'Timeline',
    field: Field,
    propertyEditor: PropertyEditor,
    isInputField: true,
    defaultProps: {
        fieldLabel: {
            label: 'Text Label',
        },
        binding: null,
        imageField: '',
        imageSize: '30',
        imageType: '',
        imageBorderType: 'square',
        imageBackgroundColor: '',
        imageIcon: '',
        imageIconColor: '',
        titleField: '',
        titleColor: '',
        titleSize: '',
        subTitleField: '',
        subTitleColor: '',
        subTitleSize: '',
        borderColor: '',
        topLabels: [],
        bottomLabels: [],
        buttons: [],
        onClick: null,
        timeline: {
            enabled: true,
            dotColor: '#424242',
            lineColor: '#424242',
            dotSize: '8',
            dotText: '',
            dotShape: 'circle',
        },

    },
});

